import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll to the top on every route change. SPAs keep the previous
 * scroll position across navigations by default, which looks broken on long
 * marketing/blog pages (you land halfway down the next article). Keyed on
 * pathname so in-page hash/query changes don't yank you to the top.
 *
 * SSR-safe: the effect never runs during the prerender's renderToString.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
